import API_URL from "@/constant/api.config";
import axios from "axios";
import { encode } from "js-base64";
import { isEmpty } from "lodash";

export const getCountries = async () => {
  const response = await axios.get(API_URL + "/countries?mode=front");
  return response.data ? response.data.data : [];
}

export const getCountryPorts = async (countryId) => {
  const response = await axios.get(API_URL + "/country-port-list/" + countryId);
  return response.data ? response.data.data : [];
}

export const getAllPorts = async (offset, limit, searchQuery) => {
  const searchQueryString = isEmpty(searchQuery) ? '' : ('/' + encode(searchQuery));
  const response = await axios
    .get(API_URL + "/all-port-list/" + offset + "/" + limit + searchQueryString);
  return response.data ? response.data.data : [];
}


export const getIPAndLocation = async () => {
  try {
    const ipResponse = await axios.get('https://api.ipify.org?format=json');
    const ip = ipResponse.data.ip;

    const locationResponse = await axios.get(`http://ip-api.com/json/${ip}`);
    const locationData = locationResponse.data;
    if (locationData.status === 'success') {
      return {
        ip: locationData.query,
        country: locationData.country,
        city: locationData.city,
        region: locationData.regionName,
        country_code: locationData.countryCode,
        timezone: locationData.timezone
      };
    } else {
      console.log('Error fetching IP or location:', locationData);
      return {
        ip: null,
        country: null,
        city: null,
        region: null,
        country_code: null,
        timezone: null
      };
    }
  } catch (error) {
    console.log('Error fetching IP or location:', error.message);
    return {
      ip: null,
      country: null,
      city: null,
      region: null,
      country_code: null,
      timezone: null
    };
  }
};

export const storedCookiesConsent = async (data, status) => {
  const payload = { ...data, status };
  const response = await axios.post(API_URL + "/user-consent", payload, {
    headers: { Accept: "application/json" },
    timeout: 10000,
  });
  return response.data ? response.data : null;
}

export const getCategories = async () => {
  const response = await axios.get(API_URL + "/categories");
  return response.data ? response.data.data : [];
}

export const supplierCountries = async (category) => {
  let cat = "";
  if (!isEmpty(category)) {
    cat = "/" + category;
  }
  const response = await axios.get(API_URL + "/supplier-product-countries" + cat);
  return response.data ? response.data.data : [];
}

export const getQtyUnits = async () => {
  const response = await axios.get(API_URL + "/quantity-units");
  return response.data ? response.data.data : [];
}

export const mpSupplierCountries = async () => {
  const response = await axios.get(API_URL + "/supplier-countries");
  return response.data ? response.data.data : [];
}

// Home Page Filter Logistic Country

export const hpLogisticCountries = async () => {
    const response = await axios.get(
        API_URL + "/logistic-countries"
    );
    return response.data || [];
};